import React from 'react';

// Renders a looping muted video cover when `coverVideo` is present, otherwise the thumbnail image.
export const CoverMedia = ({ item, className }) => {
  if (item.coverVideo) {
    return (
      <video
        src={item.coverVideo}
        className={className}
        poster={item.thumbnail}
        autoPlay
        loop
        muted
        playsInline
      />
    );
  }
  return <img src={item.thumbnail} alt={item.title} className={className} />;
};

export default CoverMedia;
